import classNames from 'classnames'
import { toast, ToastContainer } from 'react-toastify'
import { useSearchParams } from 'react-router-dom'

import { buildStateFromParams } from '../../../constants/oauth'
import { fetchIdpSignUpUrl } from '../../../actions/authActions'
import AccountSegmentSelector from '../common/AccountSegmentSelector'
import PrivacyTermsFooter from '../common/PrivacyTermsFooter'

import classes from './OAuthSignUpPage.module.scss'

const OAuthSignUpPage = () => {
  const communityId = localStorage.getItem('communityId')
  const [searchParams] = useSearchParams()

  const redirectToIdp = (segment) => {
    fetchIdpSignUpUrl()
      .then(url => {
        const state = buildStateFromParams(segment, communityId, searchParams)
        window.location.href = `${url}&state=${encodeURIComponent(state)}`
      })
      .catch(() => toast.error('Sign up is currently unavailable.'))
  }

  const handleIndividualSignUp = () => redirectToIdp('individual')
  const handleFamilySignUp = () => redirectToIdp('family')

  return (
    <main className={classNames(classes.oAuthSignUpPage, 'd-flex w-100 h-100')}>
      <div className={classNames(classes.mainCard, 'd-flex flex-column align-self-center m-auto')}>
        <h5 className={classes.titleText}>
          Let&apos;s get to know you...
          <br/>
          Which describes you best?
        </h5>

        <AccountSegmentSelector
          onIndividualClick={handleIndividualSignUp}
          onFamilyClick={handleFamilySignUp}
          showHeaders
          wrapperClassName='mb-3'
        />

        <PrivacyTermsFooter />
      </div>

      <ToastContainer theme='colored' />
    </main>
  )
}

export default OAuthSignUpPage
